import {Directive, ElementRef, OnInit} from '@angular/core';
import {isEmpty} from 'lodash';
import {FunctionUtils} from '@sharedcommon/util/functions.util';


@Directive({
  selector: '[select-all]'
})
export class InputSelectAllDirective implements OnInit {

  constructor(private elementRef: ElementRef<HTMLElement>) {
  }

  ngOnInit() {
    const element = this.elementRef.nativeElement;
    let focusableElement: HTMLInputElement | HTMLTextAreaElement = null;
    if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
      focusableElement = element;
    } else {
      focusableElement = this.findFocusableElement(element, focusableElement);
    }

    if (focusableElement) {
      focusableElement.addEventListener('focus', () => {
        if (!focusableElement.disabled) {

          // @ts-ignore
          const notSafari = FunctionUtils.isNotDefined(window.safari);
          if (notSafari) {
            focusableElement.select();
          } else {
            // Workaround for Safari bug
            setTimeout(function () {
              focusableElement.select();
            }, 10);
          }
        }
      });
    }
  }

  /**
   * 
   * @param element 
   * @param focusableElement 
   * @returns 
   */
  findFocusableElement(element, focusableElement){
    const input = element.getElementsByTagName('input');
      if (!isEmpty(input)) {
        focusableElement = input[0];
      }
      const textarea = element.getElementsByTagName('textarea');
      if (!isEmpty(textarea)) {
        focusableElement = textarea[0];
      }
      return focusableElement;
  }
}
